import { listRequest } from "@/lib/utils";

export const getContentList = (params) =>
  listRequest("/api/content/list", params);
